import React, { FC } from 'react';
import { Ellipsis } from '@infologistics/frontend-libraries';

import { IEnvelopeField } from '@store/modules/boxes/types';
import { IEnvelope } from '@store/modules/envelopes/types';
import { useAppSelector } from '@hooks/redux';
import { useTranslation } from 'react-i18next';
import { getEnvelopeFieldDisplayValue } from '../../../envelopeFieldDisplay';
import styles from '../EnvelopeItem.module.scss';

interface IProps {
  field: IEnvelopeField;
  fields: IEnvelope['fields'];
}

const EnvelopeDynamicField: FC<IProps> = ({ field, fields }) => {
  const { t } = useTranslation(['common']);
  const locale = useAppSelector((state) => state.user.profile.locale);
  const value = getEnvelopeFieldDisplayValue(field, fields?.[field.systemKey], locale, t);

  return (
    <td>
      <Ellipsis externalClass={styles.fieldValue}>{value}</Ellipsis>
    </td>
  );
};

export default EnvelopeDynamicField;
